<template>
  <div
    class="dialog-wrapper"
    :style="{
      minWidth: 0,
      maxWidth: 'calc(100vw - 2rem)',
      maxHeight: '100vh',
      overflowX: 'hidden',
      overflowY: 'auto'
    }"
  >
    <div class="header">
      <button
        v-if="canCancel"
        type="button"
        class="material-icons close"
        :aria-label="$t('@@translate@@ Close dialog')"
        @click="$emit('cancel')"
      >
        {{ $t('@@translate@@ close') }}
      </button>
      <div class="title"><slot name="header" /></div>
    </div>
    <div class="body">
      <slot />
    </div>
    <div class="footer"><slot name="footer" /></div>
  </div>
</template>

<script>
export default {
  name: 'dialog-wrapper',
  props: {
    canCancel: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
.dialog-wrapper {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(150px);
  border-radius: 20px;
  box-sizing: border-box;
  width: min(360px, 100%);
  max-width: calc(100vw - 2rem);
  max-height: calc(100dvh - 2rem);
  overflow-x: hidden;
  overflow-y: auto;
}

.header {
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 16px 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  height: 44px;
  box-sizing: border-box;
  text-transform: uppercase;
}

.close {
  border: 0;
  background: transparent;
  margin-right: 20px;
  cursor: pointer;
}

.body {
  padding: 15px;
  box-sizing: border-box;
}

.footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
}

.footer > * {
  margin: 0 5px;
}

.title {
  flex: 1;
}
</style>
